import { useCallback } from "react";
import { useBulkActions } from "../TransactionsBulkActions/useBulkActions";

interface UsePaginationWithBulkResetProps {
    onPageChange: (newPage: number) => void;
}

/**
 * Hook to handle pagination with automatic bulk selection reset
 */
export function usePaginationWithBulkReset({
    onPageChange,
}: UsePaginationWithBulkResetProps) {
    const bulkActions = useBulkActions();

    const pageChangeWithBulkActionReset = useCallback(
        (newPage: number) => {
            if (bulkActions.selectedCount && !bulkActions.hasSelectedAll) {
                bulkActions.clearSelection();
            }
            onPageChange(newPage);
        },
        [bulkActions, onPageChange],
    );

    return pageChangeWithBulkActionReset;
}
